var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../lib/nunjucks/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["escrow_www/templates/components/backArrow.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" viewBox=\"0 0 32 32\"><mask id=\"a\" width=\"11\" height=\"17\" x=\"9\" y=\"7\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m19.41 9.29-5.863 6.12 5.862 6.12-1.805 1.88-7.68-8 7.68-8 1.805 1.88Z\" clip-rule=\"evenodd\"/></mask><g mask=\"url(#a)\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"/></g></svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["escrow_www/templates/components/backArrow.html"] , dependencies)